import { Currency } from '@synergy/models';
import { InformationOutlinedIcon } from '@synergy/theme-next';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { Stack, TableCell, TableRow, Tooltip } from '@mui/material';

import { BonusConditionsPresenter } from '../../../../components/bonus-conditions-presenter/bonus-condition-presenter';
import { Conditions } from '../shared-components/conditions';
import { PriceSum } from '../shared-components/price-sum';
import { ShoppingCartSupplier } from '../../../../models/shopping-cart';

export interface SupplierTableRowProps {
    supplier: ShoppingCartSupplier;
    currency: Currency;
}

export const RowSumSupplier = (props: SupplierTableRowProps): ReactElement => {
    const { surcharges, deliveryCosts, conditions, termsOfDelivery, paymentTerm, netTotal, isChargingSupplier } =
        props.supplier;
    const { currency } = props;

    return (
        <TableRow>
            <TableCell />
            <TableCell sx={{ verticalAlign: 'top' }}>
                <Tooltip
                    title={
                        <Conditions
                            conditions={<BonusConditionsPresenter supplierConditions={conditions} />}
                            termsOfDelivery={termsOfDelivery}
                            termsOfPayment={paymentTerm}
                            isChargingSupplier={isChargingSupplier}
                        />
                    }
                    variant="light"
                    placement="bottom"
                >
                    <Stack direction="row" gap={1} sx={{ minWidth: 215 }} color="primary.main" flexWrap="nowrap">
                        <InformationOutlinedIcon />
                        <PoolTypography typography="body2" translationId="app.cart.article.price.conditions" />
                    </Stack>
                </Tooltip>
            </TableCell>
            <TableCell colSpan={2} align="right">
                <PriceSum
                    surcharges={surcharges}
                    deliveryCosts={deliveryCosts}
                    articleCosts={netTotal}
                    currency={currency}
                    isSubTotal={true}
                />
            </TableCell>
        </TableRow>
    );
};
